module.exports = __webpack_public_path__ + "static/media/exprt-02.b72a65d5.jpg";